var map = {
	"./1.1.svg": [
		"./src/assets/icons/hazmat/1.1.svg?fabd",
		"src_assets_icons_hazmat_1_1_svg"
	],
	"./1.2.svg": [
		"./src/assets/icons/hazmat/1.2.svg?89bb",
		"src_assets_icons_hazmat_1_2_svg"
	],
	"./1.3.svg": [
		"./src/assets/icons/hazmat/1.3.svg?178f",
		"src_assets_icons_hazmat_1_3_svg"
	],
	"./1.4.svg": [
		"./src/assets/icons/hazmat/1.4.svg?f0cc",
		"src_assets_icons_hazmat_1_4_svg"
	],
	"./1.5.svg": [
		"./src/assets/icons/hazmat/1.5.svg?7855",
		"src_assets_icons_hazmat_1_5_svg"
	],
	"./1.6.svg": [
		"./src/assets/icons/hazmat/1.6.svg?f5c9",
		"src_assets_icons_hazmat_1_6_svg"
	],
	"./1.svg": [
		"./src/assets/icons/hazmat/1.svg",
		"src_assets_icons_hazmat_1_svg"
	],
	"./2.1.svg": [
		"./src/assets/icons/hazmat/2.1.svg?416e",
		"src_assets_icons_hazmat_2_1_svg"
	],
	"./2.2.svg": [
		"./src/assets/icons/hazmat/2.2.svg?0aff",
		"src_assets_icons_hazmat_2_2_svg"
	],
	"./2.3.svg": [
		"./src/assets/icons/hazmat/2.3.svg?80ce",
		"src_assets_icons_hazmat_2_3_svg"
	],
	"./2.svg": [
		"./src/assets/icons/hazmat/2.svg",
		"src_assets_icons_hazmat_2_svg"
	],
	"./3.svg": [
		"./src/assets/icons/hazmat/3.svg?c7b8",
		"src_assets_icons_hazmat_3_svg"
	],
	"./4.1.svg": [
		"./src/assets/icons/hazmat/4.1.svg?bf0d",
		"src_assets_icons_hazmat_4_1_svg"
	],
	"./4.2.svg": [
		"./src/assets/icons/hazmat/4.2.svg?94f1",
		"src_assets_icons_hazmat_4_2_svg"
	],
	"./4.3.svg": [
		"./src/assets/icons/hazmat/4.3.svg?7fa0",
		"src_assets_icons_hazmat_4_3_svg"
	],
	"./4.svg": [
		"./src/assets/icons/hazmat/4.svg",
		"src_assets_icons_hazmat_4_svg"
	],
	"./5.1.svg": [
		"./src/assets/icons/hazmat/5.1.svg?6f5c",
		"src_assets_icons_hazmat_5_1_svg"
	],
	"./5.2.svg": [
		"./src/assets/icons/hazmat/5.2.svg?2770",
		"src_assets_icons_hazmat_5_2_svg"
	],
	"./6.1.svg": [
		"./src/assets/icons/hazmat/6.1.svg?def6",
		"src_assets_icons_hazmat_6_1_svg"
	],
	"./6.2.svg": [
		"./src/assets/icons/hazmat/6.2.svg?2609",
		"src_assets_icons_hazmat_6_2_svg"
	],
	"./7.svg": [
		"./src/assets/icons/hazmat/7.svg?101d",
		"src_assets_icons_hazmat_7_svg"
	],
	"./8.1.svg": [
		"./src/assets/icons/hazmat/8.1.svg?6c52",
		"src_assets_icons_hazmat_8_1_svg"
	],
	"./8.2.svg": [
		"./src/assets/icons/hazmat/8.2.svg?6eae",
		"src_assets_icons_hazmat_8_2_svg"
	],
	"./9.svg": [
		"./src/assets/icons/hazmat/9.svg?c8be",
		"src_assets_icons_hazmat_9_svg"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./src/assets/icons/hazmat lazy recursive ^\\.\\/.*\\.svg$";
module.exports = webpackAsyncContext;